export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["NA_REGISTRATION_STATUS"] = 0] = "NA_REGISTRATION_STATUS";
    RegistrationStatus[RegistrationStatus["CLOSED"] = 1] = "CLOSED";
    RegistrationStatus[RegistrationStatus["CLOSED_MANUALLY"] = 2] = "CLOSED_MANUALLY";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP"] = 3] = "OPEN_RSVP";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP_WAITLIST"] = 4] = "OPEN_RSVP_WAITLIST";
    RegistrationStatus[RegistrationStatus["OPEN_TICKETS"] = 5] = "OPEN_TICKETS";
    RegistrationStatus[RegistrationStatus["OPEN_EXTERNAL"] = 6] = "OPEN_EXTERNAL";
    RegistrationStatus[RegistrationStatus["SCHEDULED_RSVP"] = 7] = "SCHEDULED_RSVP";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP_AND_TICKETS"] = 8] = "OPEN_RSVP_AND_TICKETS";
})(RegistrationStatus || (RegistrationStatus = {}));
//# sourceMappingURL=RegistrationStatus.js.map